<template>
  <div class="detail-setting">
    <div class="header-step">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'homeworkList' }"
          v-if="type == 'homework'">{{ $t('homeworkManage.jobManagement') }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'fileList' }" v-else>{{ $t('projectDetailsV2.itemManage') }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{
          name: 'homeworkDetail', query: {
            key: $Base64.encode(JSON.stringify({
              id: $route.query.uid,
            }))
          }
        }" v-if="type == 'homework'">{{ $t('jobManagementV2.myHomework') }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ name: 'ProjectDetail', query: { id: $route.query.id } }" v-else>{{ $t('projectDetailsV2.projectDetails') }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == 'homework'">{{ $t('homeworkManage.jobSettings') }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else>{{ $t('newProjectV2.advancedSetting') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <ul class="tab">
      <li>
        <div @click="handleTab('memoryBankDetail')" :class="{ active: tabIndex === 'memoryBankDetail' }">
          {{ $t('newProjectV2.memoryBank') }}</div>
      </li>
      <li>
        <div @click="handleTab('termBankDetail')" :class="{ active: tabIndex === 'termBankDetail' }">
          {{ $t('newProjectV2.termBank') }}</div>
      </li>
      <li v-if="havePreTransTab">
        <div @click="handleTab('translationEngineDetail')" :class="{ active: tabIndex === 'translationEngineDetail' }">
          {{ $t('newProjectV2.translationEngine') }}</div>
      </li>
      <li v-if="havePreTransTab">
        <div @click="handleTab('preTranslationDetail')" :class="{ active: tabIndex === 'preTranslationDetail' }">
          {{ $t('newProjectV2.preTranslation') }}</div>
      </li>
      <li>
        <div @click="handleTab('qualityAssuranceDetail')" :class="{ active: tabIndex === 'qualityAssuranceDetail' }">
          {{ $t('newProjectV2.qualityAssurance') }}</div>
      </li>
      <!-- 短句规则 -->
      <li v-if="false">
        <div @click="handleTab('punctuateRuleDetail')" :class="{ active: tabIndex === 'punctuateRuleDetail' }">
          {{ $t('newProjectV2.punctuateRule') }}</div>
      </li>
      <li>
        <div @click="handleTab('otherSettingDetail')" :class="{ active: tabIndex === 'otherSettingDetail' }">
          {{ $t('newProjectV2.other') }}</div>
      </li>
    </ul>

    <div class="setting-content" :class="{ other: tabIndex === 'otherSettingDetail' }">
      <keep-alive>
        <component :is="tabIndex" :memoryList="memoryList" :publicMemoryList="publicMemoryList"
          :memorySimilarPercent="memorySimilarPercent" @matchRateChange="matchRateChange" :createInfo="createInfo"
          @updateMemoryBank="updateMemoryBank" :termList="termList" :publicTermList="publicTermList"
          :isTermIntervene="isTermIntervene" @changeTerm="changeTerm" :mtSupplierId="mtSupplierId"
          @translationEngineChange="translationEngineChange" :preTransList="preTransList"
          @preTransListChange="preTransListChange" :qaList="qaList" :openQa="isOpenQa"
          @selAualityIDChange="selAualityIDChange" @handleOpenQA="handleOpenQA" @percentChange="percentChange"
          @gradeChange="gradeChange" :ruleType="ruleType" :segmentRuleId="segmentRuleId" @updateRuleID="updateRuleID"
          :mtSearchId="mtSearchId" :docSetList="docSetList" @searchEngineChange="searchEngineChange"></component>
      </keep-alive>
    </div>

    <div class="setting-button">
      <button class="primary" @click="handleSave">{{ $t('projectDetailsV2.save') }}</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import { queryProjectDetails, queryTransProject, updateTransProject } from '@/services/projectDetailsApi';
import { queryDocSet, queryMemorySentCount, queryTermSentCount } from '@/services/newProjectApi';

import memoryBankDetail from './module/memoryBankDetail/newIndex.vue';
import termBankDetail from './module/termBankDetail/newIndex.vue';
import translationEngineDetail from './module/translationEngineDetail';
import preTranslationDetail from './module/preTranslationDetail';
import qualityAssuranceDetail from './module/qualityAssuranceDetail';
import punctuateRuleDetail from './module/punctuateRuleDetail';
import otherSettingDetail from './module/otherSettingDetail';

export default {
  name: 'DetailSetting',
  data() {
    return {
      havePreTransTab: havePreTransTab,
      tabIndex: 'memoryBankDetail',
      createInfo: {},

      memoryList: [],                     // 记忆库列表
      publicMemoryList: [],               // 公共记忆库     code为0
      memorySimilarPercent: 70,           // 匹配率,

      termList: [],                       // 术语库
      publicTermList: [],
      isTermIntervene: null,              // 是否开启术语干预

      mtSupplierId: null,                 // 机器翻译引擎ID

      preTransList: {
        isUseMemory: false,               // 用翻译记忆库进行预翻译
        isPreMt: false,                   // 用机器翻译进行预翻译
        isAutoCommit: false,               // 100%翻译记忆库匹配
        ifRepeatLock: false                 //锁定重复语段
      },

      qaList: [],                         // 质量检测集合
      isOpenQa: null,                     // 是否开启QA

      ruleType: 1,                        // 断句规则类型
      segmentRuleId: null,                // 断句规则ID

      mtSearchId: null,                      // 默认翻译引擎
      docSetList: [],                     // 文档设置列表
      documentSettingList: [],            // 项目勾选的

      timeOut: null,
      type: '',
    }
  },
  components: {
    memoryBankDetail,
    termBankDetail,
    translationEngineDetail,
    preTranslationDetail,
    qualityAssuranceDetail,
    punctuateRuleDetail,
    otherSettingDetail
  },
  mounted() {
    this.type = this.$route.query.type
    this.getProjectDetails();
    this.getTransProject();
  },
  methods: {
    async updateMemoryBank(type) {
      await this.getProjectDetails();
      this.tableOut(type);
    },
    tableOut(type) {
      let self = this;
      if (self.timeOut !== null) { return; }
      self.timeOut = window.setInterval(async () => {
        let list = [];

        if (type === 'memory') {
          list = self.memoryList;
        } else if (type === 'term') {
          list = self.termList;
        }

        let params = {
          idList: [],
        }

        list.forEach(item => {
          if (item.status > 1) {
            params.idList.push(item.id);
          }
        });

        if (params.idList.length < 1) {
          this.clear();
        } else {
          let resp = {};
          if (type === 'memory') {
            resp = await queryMemorySentCount(params);
          } else if (type === 'term') {
            resp = await queryTermSentCount(params);
          }
          let { success, result } = resp;
          if (success) {
            result.forEach(i => {
              list.forEach(item => {
                if (item.id === i.id) {
                  item.status = i.status;
                  item.sentCount = i.sentCount;
                }
              });
            });
          }
        }
      }, 2000);
    },
    clear() {
      if (this.timeOut === null) { return; }
      clearInterval(this.timeOut);
      this.timeOut = null;
    },
    handleSave: _.throttle(async function () {
      // 文档设置
      let documentSettingList = [];
      this.docSetList.forEach(item => {
        item.list.forEach(i => {
          if (i.isEnable) {
            documentSettingList.push(i.id);
          }
        });
      });

      // 记忆库列表
      let memoryBankArray = [];
      this.memoryList.forEach((item) => {
        if (item.isEnable) {
          memoryBankArray.push(item.id);
        }
      });
      this.publicMemoryList.forEach((item) => {
        if (item.isEnable) {
          memoryBankArray.push(item.id);
        }
      });

      // 术语库列表
      let termBankArray = [];
      this.termList.forEach(item => {
        if (item.isEnable) {
          termBankArray.push(item.id);
        }
      });
      this.publicTermList.forEach(item => {
        if (item.isEnable) {
          termBankArray.push(item.id);
        }
      });

      let param = {
        id: this.$route.query.id,
        documentSettingList: documentSettingList,
        isAutoCommit: this.preTransList.isAutoCommit ? 1 : 0,
        isOpenQa: this.isOpenQa ? 1 : 0,
        isPreMt: this.preTransList.isPreMt ? 1 : 0,
        isTermIntervene: this.isTermIntervene ? 1 : 0,
        isUseMemory: this.preTransList.isUseMemory ? 1 : 0,
        memoryLibIdList: memoryBankArray,
        memorySimilarPercent: this.memorySimilarPercent,
        mtSupplierId: this.mtSupplierId,
        qaList: this.qaList,
        transTermLibIdList: termBankArray,
        segmentRuleId: this.segmentRuleId,
        mtSearchId: this.mtSearchId,
      };

      let { success } = await updateTransProject(param);
      this.$message.closeAll();
      if (!success) {
        this.$message.warning(this.$t('projectDetailsV2.saveFail'));
        return;
      }
      this.$message.success(this.$t('projectDetailsV2.saveSuccess'));
      this.getProjectDetails();
      this.getTransProject();
      this.$router.go(-1)
    }, 2000, {
      leading: true,
      trailing: false
    }),
    async getProjectDetails() {
      let { result, success } = await queryProjectDetails({
        id: this.$route.query.id
      });

      if (!success) { return; }

      this.createInfo = result;

      // 记忆库
      let memory = result.memoryLibRespVoList || [];
      memory.forEach(item => {
        item.isEnable = Boolean(item.isEnable);
      });
      // 团队记忆库
      this.memoryList = memory.filter(item => item.companyCode !== '0');
      // 公共记忆库
      this.publicMemoryList = memory.filter(item => item.companyCode === '0');

      // 术语库
      let term = result.transTermLibRespVoList || [];
      term.forEach(item => {
        item.isEnable = Boolean(item.isEnable);
      });
      // 团队记忆库
      this.termList = term.filter(item => item.companyCode !== '0');
      // 公共记忆库
      this.publicTermList = term.filter(item => item.companyCode === '0');
    },
    async getTransProject() {
      const { result, success } = await queryTransProject({
        id: this.$route.query.id
      });
      if (!success) return;

      // 最低匹配率
      this.memorySimilarPercent = result.memorySimilarPercent;

      // 开启术语干预
      this.isTermIntervene = Boolean(result.isTermIntervene);

      // 机器翻译引擎ID
      this.mtSupplierId = result.mtSupplierId;

      // 是否启用记忆库进行预翻译
      this.preTransList.isUseMemory = Boolean(result.isUseMemory);

      // 是否预翻译
      this.preTransList.isPreMt = Boolean(result.isPreMt);

      // 是否百分百翻译记忆库匹配
      this.preTransList.isAutoCommit = Boolean(result.isAutoCommit);

      //锁定重复语段
      this.preTransList.ifRepeatLock = Boolean(result.ifRepeatLock);

      // 质量检测集合
      this.qaList = result.qaList;

      // 是否开启QA
      this.isOpenQa = Boolean(result.isOpenQa);

      // 断句规则类型
      if (result.isParagraph === null) {
        this.ruleType = 2;
      } else {
        this.ruleType = result.isParagraph;
      }

      // 断句规则ID
      this.segmentRuleId = result.segmentRuleId;

      // 搜索引擎
      this.mtSearchId = result.mtSearchId;

      // 文档设置ID集合
      this.documentSettingList = result.documentSettingList;
      this.getDocList();
    },
    // 文档设置
    async getDocList() {
      let { result } = await queryDocSet({});
      result.forEach(item => {
        item.list.forEach(i => {
          i.isEnable = false;
          if (this.documentSettingList.includes(i.id)) {
            i.isEnable = true;
          }
        });
        item.isEnable = item.list.every(item => item.isEnable === true);
      });

      this.docSetList = result;
    },
    handleTab(index) {
      this.tabIndex = index;
    },
    matchRateChange(val) {
      this.memorySimilarPercent = val;
    },
    changeTerm(val) {
      this.isTermIntervene = val;
    },
    translationEngineChange(val) {
      this.mtSupplierId = val;
    },
    preTransListChange(obj) {
      this.preTransList = obj;
    },
    selAualityIDChange(arr) {
      this.qaList = arr;
    },
    handleOpenQA(val) {
      this.isOpenQa = val;
    },
    // 百分比变化
    percentChange(item) {
      this.qaList.forEach(i => {
        if (i.id === item.id) {
          i.wordPercent = item.wordPercent;
        }
      });
    },
    // QA严重等级变化
    gradeChange(item) {
      this.qaList.forEach(i => {
        if (i.id === item.id) {
          i.grade = item.grade;
        }
      });
    },
    updateRuleID(val) {
      this.segmentRuleId = val;
    },
    searchEngineChange(val) {
      this.mtSearchId = val;
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>